var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M346.362 242c-74.439 0-135 60.561-135 135s60.561 135 135 135 135-60.561 135-135-60.561-135-135-135zm20 139c0 8.284-6.716 15-15 15H306c-8.284 0-15-6.716-15-15s6.716-15 15-15h30.362v-30.638c0-8.284 6.716-15 15-15s15 6.716 15 15z",
    fill: "#8BA4BF",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.88 405.81c-2.81.513.963.167-77.98.27-8.29 0-15-6.72-15-15s6.71-15 15-15c80.155 0 75.261-.007 75.46.01.06-10.22 1.04-20.22 2.89-29.91h-78.3c-8.29 0-15-6.72-15-15s6.71-15 15-15h87.04c24.481-61.55 84.58-104.386 153.908-104.174V59.486c0-22.817 8.589-43.663 22.697-59.486H105.03C63.69 0 30.05 33.64 30.05 74.98v421.75c0 13.494 16.507 20.123 25.84 10.37l19.19-20.04 20.27 20.28c5.85 5.85 15.35 5.85 21.21 0l19.21-19.2 19.4 19.24c5.85 5.8 15.28 5.8 21.13 0l19.71-19.54 19.72 19.54c5.84 5.8 15.26 5.8 21.11.01l3.82-3.78c-29.22-24.44-49.88-58.77-56.78-97.8zm-29.63-224.89c4.54-6.93 13.83-8.87 20.77-4.34 7.48 4.9 19.93 6.7 26.12 3.78 4.35-2.04 7.58-6.29 8.06-10.57 1.01-8.961-11.061-13.423-19.33-16.68-10.38-4.1-23.3-9.21-30.67-22.5-10.499-18.98-1.149-44.442 20.66-52.65v-2.24c0-8.28 6.72-15 15-15 8.29 0 15 6.72 15 15v1.24c6.39 1.79 12.3 4.85 16.96 9.15 6.09 5.62 6.48 15.11.86 21.2s-15.11 6.47-21.2.85c-3.42-3.16-13.17-4.36-17.73-1.3-3.21 2.16-4.78 6.54-3.3 9.21 4.201 7.603 22.834 9.223 37.26 20.47 28.119 21.915 18 61.869-12.85 72.6v3.06c0 8.28-6.71 15-15 15-8.28 0-15-6.72-15-15v-1.91c-7.99-1.71-15.44-4.79-21.27-8.6-6.93-4.54-8.87-13.83-4.34-20.77zM106 256.08h75c8.28 0 15 6.72 15 15s-6.72 15-15 15h-75c-8.29 0-15-6.72-15-15s6.71-15 15-15zM428.925 0C399.64 0 375.9 23.74 375.9 53.025V211.24h91.05c8.284 0 15-6.716 15-15V53.025C481.95 23.74 458.21 0 428.925 0z",
    fill: "#8BA4BF",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.028e254d806c78ace35b5ef5aa05ada2.svg";
export { ForwardRef as ReactComponent };